import { useEffect, useRef } from 'react';

/**
 * Панель закрылась, а элемент, с которого её открыли, исчез (строку списка
 * перерисовали: группа ушла в архив и вернулась) — фокус падает на body. Тогда
 * ставим его на кнопку той же записи в списке: `selector(id)` её находит.
 * Если панель сама вернула фокус, ничего не делаем.
 */
export function useFocusBackOnClose(openId: string | null, selector: (id: string) => string): void {
  const prev = useRef<string | null>(openId);
  useEffect(() => {
    const closed = prev.current;
    prev.current = openId;
    if (openId !== null || closed === null) return;
    const active = document.activeElement;
    if (active && active !== document.body) return;
    document.querySelector<HTMLElement>(selector(closed))?.focus({ preventScroll: true });
  }, [openId, selector]);
}
